// src/components/Icons/Icons.jsx
import React from "react";

const iconStyles = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  verticalAlign: "middle",
};

export const IconEdit = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

export const IconTrash = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

export const IconDuplicate = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
);

export const IconSearch = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
  </svg>
);

export const IconLoading = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8z">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="1s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export const IconEmail = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

export const IconPhone = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>
);

export const IconBuilding = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
  </svg>
);

export const IconSettings = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
  </svg>
);

export const IconTool = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
  </svg>
);

export const IconCalendar = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z" />
  </svg>
);

export const IconFactory = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 22H2V10l7-3v2l5-2v3h3l1-8h3l1 8v12zM12 9.95l-5 2V10l-3 1.32V20h16v-8h-3l-1-8h-1l-1 8h-2V9.95z" />
  </svg>
);

export const IconList = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
  </svg>
);

export const IconUser = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
);

export const IconCode = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
  </svg>
);

export const IconLocation = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

export const IconHash = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z" />
  </svg>
);

export const IconKey = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </svg>
);

export const IconClock = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
  </svg>
);

export const IconCheck = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

export const IconClose = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export const IconHome = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </svg>
);

export const IconPlus = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
  </svg>
);

export const IconSector = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z" />
  </svg>
);

export const IconMachine = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </svg>
);

export const IconSerial = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" />
  </svg>
);

export const IconStatus = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </svg>
);

export const IconLevel = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
  </svg>
);

export const IconRepeat = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z" />
  </svg>
);

export const IconRule = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z" />
  </svg>
);

export const IconItems = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z" />
  </svg>
);

export const IconDocument = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

export const IconEye = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
  </svg>
);

export const IconCart = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
  </svg>
);

export const IconDashboard = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
  </svg>
);

export const IconLogout = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
  </svg>
);

export const IconMenu = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

export const IconChevronDown = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
  </svg>
);

export const IconChevronRight = ({ size = "1em", color = "currentColor", style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    style={{ ...iconStyles, width: size, height: size, color, ...style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </svg>
);

export default {
  IconEdit,
  IconTrash,
  IconSearch,
  IconLoading,
  IconEmail,
  IconPhone,
  IconBuilding,
  IconSettings,
  IconTool,
  IconCalendar,
  IconFactory,
  IconList,
  IconUser,
  IconCode,
  IconLocation,
  IconHash,
  IconKey,
  IconClock,
  IconCheck,
  IconClose,
  IconHome,
  IconPlus,
  IconSector,
  IconMachine,
  IconSerial,
  IconStatus,
  IconLevel,
  IconRepeat,
  IconRule,
  IconItems,
  IconDocument,
  IconEye,
  IconCart,
  IconDashboard,
  IconLogout,
  IconMenu,
  IconChevronDown,
  IconChevronRight,
};
